var React = require('react');

function FacebookOutline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M72 8H60C54.6957 8 49.6086 10.1071 45.8579 13.8579C42.1071 17.6086 40 22.6957 40 28V40H28V56H40V88H56V56H68L72 40H56V28C56 26.9391 56.4214 25.9217 57.1716 25.1716C57.9217 24.4214 58.9391 24 60 24H72V8Z","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round"}));
}

FacebookOutline.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = FacebookOutline;

FacebookOutline.default = FacebookOutline;
